import { DEFAULT_BIKE_COLOR } from '../constants/bike';

// type - ethos/premium
// folder - path with images for 360 rendering
// wheel - sizes 16/20/24 etc.
export default class Bike {
    constructor(id, type, height, folder, colors, wheel, color = DEFAULT_BIKE_COLOR) {
        this.id = id;
        this.type = type;
        this.height = height;
        this.folder = folder;
        this.colors = colors;
        this.wheel = wheel;
        this.color = color;
    }
};


// WEBPACK FOOTER //
// ./src/classes/Bike.js